module.exports = __webpack_public_path__ + "media/images/home/big_acc-8b070769777351fa3eacd2186d69c835.svg";